import ko from 'knockout';
import templateMarkup from 'raw-loader!./kpimulticell-widget.html';

    function KpimulticellWidget(params) {

        var self = this;
        self.params = params;
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        self.widgetSignals = params.widgetSignals;

        self.panelTemplate = params.panelTemplate;

        self.subscriptions = [];

        self.getObsParams = function() {
            if (!params.observableParamsList)
                return null;

            var obsparams = params.observableParamsList[0]();

            if (params.viewLevelOptions && !$.isEmptyObject(params.viewLevelOptions())) {

                obsparams.queryId = self.panelTemplate.panelType; //'testusersummary'; //self.panelTemplate.panelType;

                var paramsTemp = params.viewLevelOptions();

                obsparams.paramsJson = ko.toJSON(paramsTemp);

                return obsparams;
            } else {
                return null;
            }
        };

        self.setObsParams = function() {

            var obsparams = self.getObsParams();
            if (!obsparams) {
                return;
            }

            if (self.widgetSignals)
                self.widgetSignals.dataRequested.dispatch();
            params.observableParamsList[0](obsparams);

        };

        self.subscriptions.push(params.viewLevelOptions.subscribe(self.setObsParams));

        self.RefreshData();

        self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
    }

    KpimulticellWidget.prototype.RefreshData = function () {
        var self = this;

        var data = self.observableData();

        if (!$.isEmptyObject(data)) {

            if (data.loadFromCacheCallback) {

                var params = self.getObsParams();
                if (!params)
                    return;

                if (!data.loadFromCacheCallback(params, data.context)) {
                    self.setObsParams();
                }
            }
        }
    };

    KpimulticellWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    KpimulticellWidget.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    KpimulticellWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });

    };

    export default { viewModel: KpimulticellWidget, template: templateMarkup };


